import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
export class videobutton {
    static init() {
        let button = document.querySelectorAll('[data-bs-toggle="video"]');
        if (button.length) {
            for (let i = 0; i < button.length; i++) {
                let dynamicGallery = button[i];
                lightGallery(dynamicGallery, {
                    selector: 'this',
                    plugins: [lgVideo],
                    licenseKey: 'D4194FDD-48924833-A54AECA3-D6F8E646',
                    download: false,
                    youTubePlayerParams: {
                        modestbranding: 1,
                        showinfo: 0,
                        rel: 0
                    },
                    vimeoPlayerParams: {
                        byline: 0,
                        portrait: 0,
                        color: '6366f1'
                    }
                });
            }
        }
    }
}
